import React from 'react';
import { DataGridExportButton, DataGridPremium } from '@clatter/ui';


const MicrositeStatisticsViewsBySiteTable = ({ isLoading = false, rows = [], columns = [], exportFileName }) => (
  <DataGridPremium
    showVerticalSidebar
    loading={isLoading}
    dataGridProps={{
      getRowClassName: ({ row }) => (row.isOdd ? 'even' : 'odd'),
    }}
    renderCustomToolbar={() => <DataGridExportButton exportFileName={exportFileName} />}
    name="report/msm-microsite-statistics-pageviews-page"
    columns={columns}
    rows={rows}
    getRowId={(row) => row.uuid}
  />
);

export default MicrositeStatisticsViewsBySiteTable;
